"use strict";

exports.__esModule = true;
exports.ConditionPanel = void 0;
var _core = require("@blueprintjs/core");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _Condition = require("../Condition");
var _constants = require("../constants");
var _ConditionContent = require("../ConditionContent");
var _vimanaTypes = require("@vimana/vimana-types");
var _styles = require("../styles");
var _SortableRows = require("../../Core/SortableRows");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ConditionPanel = exports.ConditionPanel = function ConditionPanel(_ref) {
  var conditions = _ref.conditions,
    updateCondition = _ref.updateCondition,
    setConditionArray = _ref.setConditionArray,
    noLogicExpression = _ref.noLogicExpression,
    errorMessage = _ref.errorMessage,
    classifyName = _ref.classifyName,
    _ref$isTypeDataItemOn = _ref.isTypeDataItemOnly,
    isTypeDataItemOnly = _ref$isTypeDataItemOn === void 0 ? false : _ref$isTypeDataItemOn;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var _useState = (0, _react.useState)(false),
    isPopupOpened = _useState[0],
    setIsPopupOpened = _useState[1];
  var addGroupToCondition = function addGroupToCondition() {
    setConditionArray([].concat(conditions, [{
      conditionType: "GROUP_TYPE",
      conditions: [],
      isOpen: true
    }]));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.Row, null, /*#__PURE__*/_react["default"].createElement("span", null, translate("EnrichEditorUI.ConditionPanel.Condition", "Condition")), /*#__PURE__*/_react["default"].createElement(_styles.ClassifyAddButtonsContainer, null, /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    isOpen: isPopupOpened,
    interactionKind: _core.PopoverInteractionKind.CLICK,
    position: _core.Position.BOTTOM,
    enforceFocus: true,
    content: !isTypeDataItemOnly && /*#__PURE__*/_react["default"].createElement(_Condition.ConditionTypePopup, {
      conditions: conditions,
      setConditionArray: setConditionArray,
      onClose: function onClose() {
        return setIsPopupOpened(!isPopupOpened);
      }
    })
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "EnrichEditorUI.ConditionPanel.AddCondition",
    icon: "plus",
    intent: _core.Intent.PRIMARY,
    onClick: function onClick() {
      if (isTypeDataItemOnly) {
        {
          setConditionArray([].concat(conditions, [{
            conditionType: _constants.ConditionTypes[2].key
          }]));
        }
      } else {
        setIsPopupOpened(!isPopupOpened);
      }
    }
  }, translate("EnrichEditorUI.ConditionPanel.AddCondition", "Add condition"))), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "EnrichEditorUI.ConditionPanel.AddGroup",
    icon: "plus",
    intent: _core.Intent.PRIMARY,
    onClick: addGroupToCondition,
    style: {
      marginLeft: "5px"
    }
  }, translate("EnrichEditorUI.ConditionPanel.AddCompound", "Add compound")))), !(0, _utils.validateConditionsNumber)(conditions) ? /*#__PURE__*/_react["default"].createElement(_styles.Row, null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "rgb(194, 48, 48)"
    }
  }, errorMessage)) : null, /*#__PURE__*/_react["default"].createElement(_SortableRows.AccordionSortableRows, {
    items: conditions,
    renderItem: function renderItem() {
      return null;
    },
    getKey: function getKey(_v, i) {
      return classifyName + "-Condition-" + i;
    },
    renderSubRow: function renderSubRow(condition, index, array) {
      var _conditions$index;
      return /*#__PURE__*/_react["default"].createElement(_ConditionContent.ConditionContent, {
        condition: condition,
        singleCondition: (conditions == null ? void 0 : conditions.length) === 1 && ((_conditions$index = conditions[index]) == null ? void 0 : _conditions$index.conditionType) !== "GROUP_TYPE",
        first: index === 0 || noLogicExpression,
        updateSelf: updateCondition(condition, index, array),
        classifyName: classifyName,
        isTypeDataItemOnly: isTypeDataItemOnly
      });
    },
    getHeader: function getHeader(condition, index, array) {
      return /*#__PURE__*/_react["default"].createElement(_Condition.Condition, {
        condition: condition,
        first: index === 0 || noLogicExpression,
        updateSelf: updateCondition(condition, index, array)
      });
    },
    setItems: function setItems(conditions) {
      setConditionArray(conditions);
    },
    toggleItem: function toggleItem(condition, i, conditions) {
      var newCond = conditions.slice();
      newCond[i] = Object.assign({}, condition, {
        isOpen: !condition.isOpen
      });
      setConditionArray(newCond);
    },
    isOpen: function isOpen(condition) {
      return condition.isOpen != null ? condition.isOpen : true;
    }
  }));
};